import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_ENT_CARRERAS = 'ALL_ENT_CARRERAS';
export const LOADING_ALL_ENT_CARRERAS = 'LOADING_ALL_ENT_CARRERAS';
export const ACTIVO_ENT_CARRERAS = 'ACTIVO_ENT_CARRERAS';
export const PARAMS_ENT_CARRERAS = 'PARAMS_ENT_CARRERAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const entCarrerasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ENT_CARRERAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_ENT_CARRERAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ENT_CARRERAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_ENT_CARRERAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
